import moment from 'moment';

const getDateFromTimestamp = (timestamp) => moment.unix(timestamp).utc().toDate();

export default getDateFromTimestamp;
